package tta.destinigo.talktoastro.feature_profile.transaction_history.persentation

import tta.destinigo.talktoastro.feature_profile.transaction_history.data.response.TransactionOrderData


sealed class TransactionHistoryState {
    data class Error(val msg: String) : TransactionHistoryState()
    data class Loading(val isLoading: Boolean) : TransactionHistoryState()
    data class TransactionInfoSuccess(val data: List<TransactionOrderData>) : TransactionHistoryState()
}